import React, { useEffect, useState } from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  CheckboxGroupInput,
  DateInput,
  required,
  SelectInput,
  useNotify,
  BooleanInput,
  RadioButtonGroupInput,
} from 'react-admin';
import '../user-styles.css';
import { getAddons, getFormattedDate, getLocations, getRoles } from '../utils';
import { GENDER_OPTIONS, USER_ROLES } from '../utils/constants';
import history from '../history';
import { customDataProvider } from '../data-provider';

const validateRequired = [required()];

export const TeamMemberCreate = props => {
  const [selectedRole, setSelectedRole] = useState([]);
  const [addonsList, setAddonsList] = useState([]);
  const notify = useNotify();
  const role = localStorage.getItem('role');

  const workLocations = JSON.parse(localStorage.getItem('userWorkLocations'));

  const todayDate = getFormattedDate(new Date());

  useEffect(() => {
    if (selectedRole === 'therapist') {
      customDataProvider
        .getList('service-addons', {
          locationId: '1',
        })
        .then(data => {
          setAddonsList(data?.data);
        });
    }
  }, [selectedRole]);

  const onSuccess = () => {
    history.push('/employee');
  };
  return (
    <Create {...props} onSuccess={onSuccess}>
      <SimpleForm initialValues={{ gender: 1, role: 'admin' }}>
        <TextInput
          source="first_name"
          label="First Name"
          validate={validateRequired}
        />
        <TextInput
          source="last_name"
          label="Last Name"
          validate={validateRequired}
        />
        <TextInput source="email" label="Email" validate={validateRequired} />
        {/* <DateInput source="dob" label="DOB" validate={validateRequired} /> */}
        <TextInput source="phone" label="Phone" validate={validateRequired} />
        <SelectInput
          source="gender"
          label="Gender"
          optionText="name"
          choices={GENDER_OPTIONS}
          validate={validateRequired}
        />
        <SelectInput
          source="role"
          optionText="name"
          choices={getRoles(role, USER_ROLES)}
          label="Role"
          onChange={e => setSelectedRole(e.target.value)}
          validate={validateRequired}
        />
        {selectedRole === 'therapist' ? (
          <RadioButtonGroupInput
            source="location"
            label="Location"
            choices={getLocations(workLocations)}
            validate={validateRequired}
          />
        ) : (
          <CheckboxGroupInput
            source="locations"
            label="Locations"
            choices={getLocations(workLocations)}
            validate={validateRequired}
          />
        )}

        <TextInput
          source="service_ref_id"
          label="Service Reference Id"
          validate={validateRequired}
        />
        {selectedRole === 'therapist' && (
          <>
            <TextInput
              multiline
              source="bio"
              label="Bio"
              validate={validateRequired}
            />

            <BooleanInput
              label="Prenatal Certified?"
              options={{
                id: 'pregnancy',
              }}
              source="pregnancy"
            />

            <TextInput
              source="license_number"
              label="License Number"
              validate={validateRequired}
            />
            <br />
            <DateInput
              source="license_expiration"
              defaultValue=""
              label="License Expiration"
              validate={validateRequired}
            />

            <CheckboxGroupInput
              label="Addons"
              source="addon_type_ids"
              choices={getAddons(addonsList)}
              FormGroupProps={{
                style: {
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  gap: '12px',
                  alignItems: 'center',
                },
              }}
            />
          </>
        )}
      </SimpleForm>
    </Create>
  );
};
